import React, { useState, useRef, useEffect } from "react";

interface TooltipProps {
    content: React.ReactNode;
    children: React.ReactNode;
    delay?: number;
    className?: string;
    position?: 'top' | 'bottom';
}

export const Tooltip: React.FC<TooltipProps> = ({
    content,
    children,
    delay = 200,
    className = "",
    position = 'top'
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const showTooltip = () => {
        timeoutRef.current = setTimeout(() => {
            setIsVisible(true);
        }, delay);
    };

    const hideTooltip = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsVisible(false);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <div
            className={`relative inline-block ${className}`}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            onFocus={showTooltip}
            onBlur={hideTooltip}
        >
            {children}
            {isVisible && (
                <div role="tooltip" className={`
                    absolute z-50 left-1/2 transform -translate-x-1/2 px-3 py-2 text-xs font-medium text-white bg-gray-900 rounded-lg shadow-sm dark:bg-gray-700 whitespace-normal min-w-[200px] max-w-xs break-words
                    ${position === 'top' ? 'bottom-full mb-2' : 'top-full mt-2'}
                `}>
                    {content}
                    <div className={`
                        absolute left-1/2 transform -translate-x-1/2 border-4 border-transparent
                        ${position === 'top'
                            ? 'top-full -mt-1 border-t-gray-900 dark:border-t-gray-700'
                            : 'bottom-full -mb-1 border-b-gray-900 dark:border-b-gray-700'}
                    `}></div>
                </div>
            )}
        </div>
    );
};
